import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import RoutingManager, { IRouteHistory, Route } from '../../components/routing/Routing'
import { CSIFieldOption } from '../../managers/ContractsManager'
import { IUserRole } from '../../definitions/Permissions'

export interface IInitial {
    currentRoute: Route
    routeParams: any
    routeHistory: IRouteHistory[]
    JWT: string
    selectedFields: CSIFieldOption[]
    allUserRoles: IUserRole[]
    debugMode: boolean
}

const INITIAL: IInitial = {
    currentRoute: 'overview',
    routeParams: null,
    routeHistory: [{ route: 'overview' }],
    JWT: null,
    selectedFields: ['all'],
    allUserRoles: [],
    debugMode: false
}

const appSlice = createSlice({
    name: 'session',
    initialState: INITIAL,
    reducers: {
        changeRoute: (state, action: PayloadAction<IRouteHistory>) => {
            state.currentRoute = action.payload.route
            state.routeParams = action.payload.params

            if (!state.routeHistory) state.routeHistory = []
            state.routeHistory = RoutingManager.changeRoute(action.payload, state.routeHistory)
        },
        overwriteRouteParams: (state, action: PayloadAction<any>) => {
            state.routeParams = action.payload
        },
        setJWT: (state, action: PayloadAction<string>) => {
            state.JWT = action.payload
        },
        setSelectedFields(state, action: PayloadAction<CSIFieldOption[]>) {
            state.selectedFields = action.payload
        },
        setAllUserRoles(state, action: PayloadAction<IUserRole[]>) {
            state.allUserRoles = action.payload
        },
        setDebugMode(state, action: PayloadAction<boolean>) {
            state.debugMode = action.payload
        }
    }
})

export const { changeRoute, setJWT, overwriteRouteParams, setSelectedFields, setAllUserRoles, setDebugMode } = appSlice.actions
export default appSlice.reducer
